import { CityReview } from 'src/app/model/city.review';
import { Action } from '@ngrx/store';

export enum CityProductionActionTypes {
  LoadDataReview = '[City] Load data from reviews back',
  LoadDataReviewSuccessful = '[City] Successfull loaded data',
  LoadDataReviewError = '[City] data error',
  RedirectAction = '[City] redirect action',
  NextStep = '[City] Change of step',
  SetStep = '[City] Set current step',
  FinishReview = '[City] Finish Review',
  ChangeNavigation = '[City] Change Navigation',
  SaveReview = '[City] Save Review',
  SaveReviewError = '[City] Save review error',
  SaveReviewSuccess = '[City] Successful save review',
  UpdateDataReview = '[City] update data review',
  UpdateLandscapes = '[City] landscapes update',
  UpdateExperiences = '[City] experiences update',
  UpdateMotivations = '[City] motivations update',
  UpdateTravelers = '[City] travelers update',
  UpdateDayRange = '[City] day range update',
  UpdateFeedback = '[City] feedback update',
  UpdateAnsweredQuestions = '[City] answered questions update',
  UpdateConsent = '[City] consent update',
  UpdateReview = '[City] update review',
  PreviousStep = '[City] Previous step'
}

export class ChangeNavigationAction {
  readonly type = CityProductionActionTypes.ChangeNavigation;
  constructor(readonly payload: { route: string }) {}
}

export class LoadDataReviewAction implements Action {
  readonly type = CityProductionActionTypes.LoadDataReview;
  constructor(readonly payload: { transactionId: string; hash: string; test: boolean }) {}
}

export class LoadDataReviewSuccessAction {
  readonly type = CityProductionActionTypes.LoadDataReviewSuccessful;
  constructor(readonly payload: any) {}
}

export class LoadDataReviewError {
  readonly type = CityProductionActionTypes.LoadDataReviewError;
  constructor() {}
}

export class RedirectAction {
  readonly type = CityProductionActionTypes.RedirectAction;
  constructor() {}
}

export class NextStepAction {
  readonly type = CityProductionActionTypes.NextStep;
  constructor() {}
}

export class SetStepAction {
  readonly type = CityProductionActionTypes.SetStep;
  constructor(readonly payload: { id: string; save: boolean }) {}
}

export class SaveReview implements Action {
  readonly type = CityProductionActionTypes.SaveReview;
  constructor(
    readonly payload: { transactionId: string; hash: string; cityReview: CityReview; locale: string; test: boolean }
  ) {}
}

export class SaveReviewSuccess implements Action {
  readonly type = CityProductionActionTypes.SaveReviewSuccess;
  constructor(readonly payload: any) {}
}

export class SaveReviewError implements Action {
  readonly type = CityProductionActionTypes.SaveReviewError;
  constructor(readonly payload: { error: any }) {}
}

export class PreviousStepAction {
  readonly type = CityProductionActionTypes.PreviousStep;
  constructor() {}
}

export class UpdateReview implements Action {
  readonly type = CityProductionActionTypes.UpdateReview;
  constructor(
    readonly payload: {
      id: string;
      transactionId: string;
      hash: string;
      cityReview: CityReview;
      locale: string;
      test: boolean;
    }
  ) {}
}

export class UpdateDataReview implements Action {
  readonly type = CityProductionActionTypes.UpdateDataReview;
  constructor(readonly payload: any) {}
}
export class UpdateLandscapes implements Action {
  readonly type = CityProductionActionTypes.UpdateLandscapes;
  constructor(readonly payload: any) {}
}

export class UpdateExperiences implements Action {
  readonly type = CityProductionActionTypes.UpdateExperiences;
  constructor(readonly payload: any) {}
}

export class UpdateMotivations implements Action {
  readonly type = CityProductionActionTypes.UpdateMotivations;
  constructor(readonly payload: any) {}
}

export class UpdateTravelers implements Action {
  readonly type = CityProductionActionTypes.UpdateTravelers;
  constructor(readonly payload: any) {}
}

export class UpdateDayRange implements Action {
  readonly type = CityProductionActionTypes.UpdateDayRange;
  constructor(readonly payload: any) {}
}

export class UpdateFeedback implements Action {
  readonly type = CityProductionActionTypes.UpdateFeedback;
  constructor(readonly payload: any) {}
}

export class UpdateAnsweredQuestions implements Action {
  readonly type = CityProductionActionTypes.UpdateAnsweredQuestions;
  constructor(readonly payload: any) {}
}

export class UpdateConsent implements Action {
  readonly type = CityProductionActionTypes.UpdateConsent;
  constructor(readonly payload: any) {}
}

export type CityAction =
  | LoadDataReviewAction
  | LoadDataReviewSuccessAction
  | LoadDataReviewError
  | RedirectAction
  | NextStepAction
  | SetStepAction
  | ChangeNavigationAction
  | SaveReviewError
  | SaveReviewSuccess
  | SaveReview
  | UpdateDataReview
  | UpdateLandscapes
  | UpdateExperiences
  | UpdateMotivations
  | UpdateTravelers
  | UpdateDayRange
  | UpdateFeedback
  | UpdateAnsweredQuestions
  | UpdateReview
  | PreviousStepAction
  | UpdateConsent;
